"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @hidden
 */
var ListFilter = /** @class */ (function (_super) {
    __extends(ListFilter, _super);
    function ListFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListFilter.prototype.render = function () {
        var _this = this;
        return (React.createElement("span", { className: "k-list-filter" },
            React.createElement("input", { ref: function (input) { return _this.input = input; }, value: this.props.value || '', className: "k-textbox", onChange: this.props.onChange, onKeyDown: this.props.onKeyDown }),
            React.createElement("span", { className: "k-icon k-i-search" })));
    };
    return ListFilter;
}(React.Component));
exports.default = ListFilter;
//# sourceMappingURL=ListFilter.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dropdowns@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_re_vkmwb4tr3wvnf7qdjhi25kjvza/~/@progress/kendo-react-dropdowns/dist/npm/common/ListFilter.js
// module id = 6546
// module chunks = 0